<template>
  <v-expansion-panels v-model="ordersPanel">
    <v-expansion-panel>
      <v-expansion-panel-header class="text-h6 font-weight-regular">
        <v-row>
          <v-col md="auto">
            {{ $t('ORDERS.ITEMS') }}
          </v-col>
          <v-spacer />
          <v-col md="auto">
            <v-btn
              class="mr-4"
              color="indigo"
              outlined
              @click.stop="createOrder"
            >
              <v-icon left>mdi-plus</v-icon>
              {{ $t('ITEM.NEW') }} {{ $t('ORDERS.ITEM') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <orders-list
          type="b"
          :items="items"
          :meta="meta"
          :options.sync="options"
          @show="showOrder"
        />
      </v-expansion-panel-content>
    </v-expansion-panel>

    <create-business-order-popup
      v-if="createDialog"
      v-model="createDialog"
      :company-id="companyId"
    />
  </v-expansion-panels>
</template>

<script>
import { mapActions } from 'vuex';
import { getViewRouteNameByOrderType } from '@/modules/orders/common/utils';

import listOptions, {
  DEBOUNCE_DELAY
} from '@/modules/_global/mixins/list-options';
import { debounce } from 'lodash';
import CreateBusinessOrderPopup from '@/modules/orders/components/CreateBusinessOrderPopup.vue';

export default {
  name: 'CompanyOrdersList',

  components: {
    CreateBusinessOrderPopup,
    OrdersList: () => import('@/modules/orders/components/OrdersList.vue')
  },

  mixins: [listOptions],

  props: {
    companyId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      createDialog: false,
      ordersPanel: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['date_entered'],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false
      }
    };
  },

  created() {
    this.refreshData();
  },

  methods: {
    ...mapActions('company', ['getOrders']),

    getListData: debounce(function getDebouncedListData() {
      this.getOrders({
        companyId: this.companyId,
        params: this.params.paginationOptions
      }).then(({ data }) => {
        this.items = data.data;
        this.meta = data.meta;
      });
    }, DEBOUNCE_DELAY),

    showOrder(order) {
      const routeName = getViewRouteNameByOrderType(order.type_id);

      if (routeName) {
        this.$router.push({
          name: routeName,
          params: { id: order.id }
        });
      }
    },

    createOrder() {
      this.createDialog = true;
    }
  }
};
</script>

<style scoped></style>
